._BooleanEqual_1ti56_1 {
  width: 100%;
}